<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->

<div
  class="bulk-update-modal-overlay"
  (click)="onClose()"
  (keydown.escape)="onClose()">
  <dialog
    class="bulk-update-modal"
    open
    (click)="$event.stopPropagation()"
    (keydown.escape)="onClose()">
    <div class="modal-header">
      <h2 class="modal-title">Process Request(s)</h2>
      <p class="modal-subtitle">
        Updating {{ selectedRequestsCount }} selected request(s)
      </p>
      <button
        type="button"
        class="close-btn"
        (click)="onClose()"
        aria-label="Close modal">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="bulk-update-form">
      <div class="form-content">
        <!-- Assigned To -->
        <div class="form-group">
          <label for="assignedTo">Assigned User</label>
          <select
            id="assignedUser"
            formControlName="assignedUser"
            class="form-select">
            <option value="">-- Select User --</option>
            @for (user of availableUsers; track user) {
              <option [value]="user.id">
                {{ user.userName }}
              </option>
            }
          </select>
        </div>

        <!-- Print Site -->
        <div class="form-group">
          <label for="printSite">Print Site</label>
          <select
            id="printSite"
            formControlName="printSiteId"
            class="form-select">
            <option value="">-- Select Print Site --</option>
            @for (site of availablePrintSites; track site) {
              <option [value]="site.id">
                {{ site.printSiteName }}
              </option>
            }
          </select>
        </div>

        <div class="form-group">
          <label for="printLocationId"> Print Location </label>

          <select
            id="printLocationId"
            formControlName="printLocationId"
            class="form-select"
            [disabled]="isPrintLocationDisabled">
            <option value="">-- Select Print Location --</option>

            @for (location of availablePrintLocations; track location) {
              <option [value]="location.id">
                {{ location.locationName }}
              </option>
            }
          </select>
        </div>

        <div class="form-group checkbox-group">
          <label class="checkbox-label">
            <input
              type="checkbox"
              formControlName="printPostage"
              class="checkbox-input" />

            <span>Print Postage</span>
          </label>
        </div>

        <!-- Comments -->
        <div class="form-group full-width">
          <label for="comments">Comments</label>
          <textarea
            id="comments"
            formControlName="comment"
            class="form-textarea"
            rows="4"
            placeholder="Add any additional notes..."></textarea>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn-cancel"
          (click)="onClose()"
          [disabled]="isSubmitting">
          Cancel
        </button>
        <ukg-button
          emphasis="high"
          [attr.disabled]="!form.valid || isSubmitting ? '' : null"
          (click)="onSubmit()">
          @if (!isSubmitting) {
            <span>Update Requests</span>
          }
          @if (isSubmitting) {
            <span>
              <ukg-progress-circular></ukg-progress-circular>
              Updating...
            </span>
          }
        </ukg-button>
      </div>
    </form>
  </dialog>
</div>
